import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import AppShell from "./AppShell";
import { LineChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from "recharts";

export default function Monitoring() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/monitoring/history").then((r) => {
      setHistory(r.data);
      setLoading(false);
    });
  }, []);

  const labelled = history.map((h, i) => ({ ...h, idx: i + 1 }));

  const min = labelled.length ? Math.min(...labelled.map((d) => d.score)) : 0;
  const max = labelled.length ? Math.max(...labelled.map((d) => d.score)) : 0;
  const delta = labelled.length >= 2 ? labelled[labelled.length - 1].score - labelled[0].score : 0;

  return (
    <AppShell title="Monitoring" subtitle="// score trend over time">
      <div data-testid="monitoring-page">
        {loading ? (
          <div className="font-mono text-sm">Loading…</div>
        ) : labelled.length < 2 ? (
          <div className="border border-dashed border-border p-12 text-center bg-card">
            <h2 className="font-marketing text-2xl">Not enough data yet.</h2>
            <p className="mt-2 text-muted-foreground">Run a couple of audits to see your visibility trend over time.</p>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-3 gap-4">
              <div className="border border-border bg-card p-6">
                <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Latest</div>
                <div className="mt-2 font-mono text-4xl">{labelled[labelled.length - 1].score}</div>
              </div>
              <div className="border border-border bg-card p-6">
                <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Best</div>
                <div className="mt-2 font-mono text-4xl">{max}</div>
              </div>
              <div className="border border-border bg-card p-6">
                <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Δ since start</div>
                <div className={`mt-2 font-mono text-4xl ${delta >= 0 ? "text-emerald-700" : "text-intl"}`}>{delta >= 0 ? "+" : ""}{delta}</div>
              </div>
            </div>

            <div className="mt-6 border border-border bg-card p-6 h-96">
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={labelled}>
                  <CartesianGrid stroke="#E8E8E3" vertical={false} />
                  <XAxis dataKey="idx" tick={{ fill: "#5C5C5C", fontFamily: "IBM Plex Mono", fontSize: 11 }} axisLine={false} tickLine={false} />
                  <YAxis domain={[Math.max(0, min - 10), 100]} tick={{ fill: "#5C5C5C", fontFamily: "IBM Plex Mono", fontSize: 11 }} axisLine={false} tickLine={false} />
                  <Tooltip contentStyle={{ background: "#0A0A0A", color: "#F5F5F0", border: "none", borderRadius: 0, fontFamily: "IBM Plex Mono", fontSize: 12 }} formatter={(v) => [v, "score"]} />
                  <Line type="monotone" dataKey="score" stroke="#FF4F00" strokeWidth={2} dot={{ r: 4, fill: "#FF4F00", strokeWidth: 0 }} />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </>
        )}
      </div>
    </AppShell>
  );
}
